import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'rootReducer';
import { EventModel } from 'features/events/EventModel';
import { upcomingOrLiveSelector } from 'features/events/eventsSelectors';
import { EmptyEvents } from 'features/channel/components/ChannelEvents/EmptyEvents';
import { PaginatedEvents } from 'features/channel/components/ChannelEvents/PaginatedEvents';

export const ChannelEvents: FunctionComponent = () => {
  const channel = useSelector(
    (state: RootState) => state.channel.channelDetails
  );
  const channelisLoaded = useSelector(
    (state: RootState) => state.channel.isLoaded
  );
  const allUpcomingEvents: EventModel[] = useSelector(upcomingOrLiveSelector);

  if (!channelisLoaded || channel == null) {
    return null;
  }

  if (allUpcomingEvents.length === 0) {
    return <EmptyEvents username={channel.username} />;
  }

  return <PaginatedEvents events={allUpcomingEvents} itemsPerPage={20} />;
};
